import useTlmCart from '~/composable/useTlmCart';
import { STEP_TYPE } from '~/constants/StepType';
import useCustomer from '~/composable/customer/useCustomer';
import useMitID from '~/composable/useMitID';
import useCheckoutInfo from '~/composable/useCheckoutInfo';
import { VALIDATION_STATUS } from '~/constants/ValidationStatus';
import { CUSTOMER_TYPE } from '~/constants/CheckoutFlow';
export default function cashFlowHandler () {
  const validValidationPromise = () => {
    return Promise.resolve({
      actionStatus: VALIDATION_STATUS.VALID,
      signupBlockingNotifications: [],
      hasSignupBlockingNotification: false
    });
  }
  const initialize = () => {
    return true;
  }

  const preValidate = () => {
    return validValidationPromise();
  }

  const validate = () => {
    return validValidationPromise();
  }

  const execute = () => {
    return validValidationPromise();
  }

  const finalize = () => {
    return validValidationPromise();
  }

  // Helper to build shipping address with optional drop point fields
  // eslint-disable-next-line complexity
  const buildShippingFromPickup = (pickup, billingAddressDTO) => {
    const hasPickupAddress = Boolean(
      pickup &&
      pickup.streetName &&
      pickup.streetNumber &&
      pickup.postalCode &&
      pickup.city
    )

    if (!hasPickupAddress) {
      return {
        shippingAddressDTO: billingAddressDTO,
        useBillingAddressAsShipping: true
      }
    }

    return {
      shippingAddressDTO: {
        firstName: pickup.name,
        lastName: '',
        company: '',
        streetName: pickup.streetName,
        houseNumber: pickup.streetNumber,
        postalCode: pickup.postalCode,
        postalDistrict: pickup.city,
        floor: '',
        side: '',
        dropPointName: pickup.name,
        dropPointId: pickup.id,
        dropPointDistance: pickup.distance
      },
      useBillingAddressAsShipping: false
    }
  }

  // eslint-disable-next-line complexity
  const finalizeCustomerInfoStep = async (state, appContext) => {
    const { customerInfo } = state
    const { menu, privateInfo, businessInfo } = customerInfo
    const customerDetails = customerInfo.customerDetails
    const { addAddressInformation } = useCustomer(appContext)
    const { getCartID, cartHasHardware } = useTlmCart(appContext)
    const { getMitIdToken } = useMitID(appContext)

    // MIO-29627: block Erhvervskunde device/hardware cash checkout (API also enforces)
    if (menu.value === CUSTOMER_TYPE.BUSINESS && cartHasHardware.value) {
      menu.value = CUSTOMER_TYPE.PRIVATE
      return
    }

    const billingAddressDTO = customerDetails.value.addressDTO

    let pickup
    if (menu.value === CUSTOMER_TYPE.PRIVATE) {
      pickup = privateInfo && privateInfo.pickupLocation
    } else if (menu.value === CUSTOMER_TYPE.BUSINESS) {
      pickup = businessInfo && businessInfo.pickupLocation
    } else {
      return
    }

    const { shippingAddressDTO, useBillingAddressAsShipping } = buildShippingFromPickup(pickup, billingAddressDTO)

    await addAddressInformation({
      useBillingAddressAsShipping,
      shippingAddress: shippingAddressDTO,
      billingAddress: billingAddressDTO,
      emailAddress: customerDetails.value.email,
      cvrNumber: customerDetails.value.cvrNumber,
      cartID: getCartID.value,
      emptyCvrCprInCart: true,
      // Keep tempAddressIdentifier behavior from main for compatibility
      tempAddressIdentifier: getMitIdToken()
    })
  };

  // eslint-disable-next-line complexity
  const finalizeCustomerInfoConfirmationStep = async (state, appContext) => {
    const { customerInfo } = state;
    const customerDetails = customerInfo.customerDetails;
    const { addAddressInformation } = useCustomer(appContext);
    const { getCartID } = useTlmCart(appContext);
    const { getMitIdToken } = useMitID(appContext);
    const { addPermissionInformation, addPrepaidEmail } = useCheckoutInfo(appContext);

    const billingAddressDTO = customerDetails.value.addressDTO;
    const { menu, privateInfo, businessInfo } = customerInfo;

    let pickup
    if (menu.value === CUSTOMER_TYPE.PRIVATE) {
      pickup = privateInfo && privateInfo.pickupLocation
    } else if (menu.value === CUSTOMER_TYPE.BUSINESS) {
      pickup = businessInfo && businessInfo.pickupLocation
    }

    const { shippingAddressDTO, useBillingAddressAsShipping } = buildShippingFromPickup(pickup, billingAddressDTO)
    await addAddressInformation({
      useBillingAddressAsShipping,
      shippingAddress: shippingAddressDTO,
      billingAddress: billingAddressDTO,
      emailAddress: customerDetails.value.email,
      cartID: getCartID.value,
      tempAddressIdentifier: getMitIdToken()
    });
    await addPermissionInformation({
      permissionEmail: customerInfo.permissionsAccepted.value,
      permissionSms: customerInfo.permissionsAccepted.value,
      permissionCall: customerInfo.permissionsAccepted.value,
      permissionTermsText: customerInfo.permissionText1 + customerInfo.permissionText2 + customerInfo.linkText1
    });
    await addPrepaidEmail(customerInfo.customerDetails.value.email);
  };

  const finalizeStep = async (stepType, state, appContext) => {
    if (stepType === STEP_TYPE.CUSTOMER_INFO) {
      await finalizeCustomerInfoStep(state, appContext);
      return;
    }
    if (stepType === STEP_TYPE.CUSTOMER_INFO_CONFIRMATION) {
      await finalizeCustomerInfoConfirmationStep(state, appContext);
      return;
    }
    if (stepType === STEP_TYPE.CONFIRMATION) {
      return;
    }
    return true;
  };
  return {
    initialize,
    preValidate,
    validate,
    finalize,
    execute,
    finalizeStep
  }
}
